import { render, staticRenderFns } from "./LocationsTab.vue?vue&type=template&id=6931eca7&scoped=true"
import script from "./LocationsTab.vue?vue&type=script&lang=js"
export * from "./LocationsTab.vue?vue&type=script&lang=js"
import style0 from "./LocationsTab.vue?vue&type=style&index=0&id=6931eca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931eca7",
  null
  
)

export default component.exports